import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class NumberOfItems extends PrimitiveValueObject<number> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: number): NumberOfItems {
    return new NumberOfItems(value);
  }
}
